import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source), true)).call(_context5, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context6; _forEachInstanceProperty(_context6 = ownKeys(Object(source))).call(_context6, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import Box from '@rexlabs/box';
import { useToken, useStyles, StyleSheet, StylesProvider, text, border, focus } from '@rexlabs/styling';
import { TextInput as LunaTextInput } from '@rexlabs/text-input';
import { Suffix } from './suffix';
import { useSelect } from '../../hooks/use-select';
var defaultStyles = StyleSheet({
  container: _objectSpread({}, border.styles({
    target: 'select.textInput.container',
    bottom: {
      width: 'thin',
      color: 'container.static.light'
    }
  }))
});
var overrides = {
  textInput: _objectSpread(_objectSpread({}, border.tokens({
    all: {
      width: 'none'
    }
  })), {}, {
    focus: _objectSpread({}, focus.tokens({
      shadow: function shadow() {
        return 'none';
      }
    })),
    disabled: _objectSpread(_objectSpread({}, border.tokens({
      target: ['select.textInput', 'textInput'],
      all: {
        color: 'input.idle'
      }
    })), {}, {
      background: {
        color: function color(_ref) {
          var token = _ref.token;
          return token('color.input.idle');
        }
      },
      hover: _objectSpread({}, border.tokens({
        target: ['select.textInput', 'textInput'],
        all: {
          color: 'input.hover'
        }
      }))
    }),
    input: {
      disabled: _objectSpread({}, text.tokens({
        target: ['select.textInput', 'textInput.input'],
        fallback: 'normal.default',
        color: function color(_ref2) {
          var token = _ref2.token;
          return token('color.textStyle.body.default');
        }
      }))
    }
  })
};
export var TextInput = /*#__PURE__*/forwardRef(function TextInput(props, ref) {
  var _context, _context2, _context3, _context4;

  var s = useStyles(defaultStyles);
  var token = useToken();

  var _useSelect = useSelect(),
      searchable = _useSelect.searchable; // Calculated height of this text input should be
  // the original height minus the top and bottom border


  var height = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "calc(".concat(token('textInput.height', '4rem'), " - (")).call(_context2, token('textInput.border.top.width', token('border.width.thin', '0.1rem')), " + ")).call(_context, token('textInput.border.bottom.width', token('border.width.thin', '0.1rem')), "))");

  var minHeight = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "calc(".concat(token('textInput.height', '4rem'), " - (")).call(_context4, token('textInput.border.top.width', token('border.width.thin', '0.1rem')), " + ")).call(_context3, token('textInput.border.bottom.width', token('border.width.thin', '0.1rem')), "))");

  return /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: overrides
  }, /*#__PURE__*/React.createElement(Box, s('container'), /*#__PURE__*/React.createElement(LunaTextInput, _extends({}, props, {
    ref: ref,
    disabled: !searchable,
    containerProps: {
      style: {
        height: height,
        minHeight: minHeight
      }
    },
    Suffix: Suffix
  }))));
});